<template>
    <ul class="mc-select-group__wrap">
        <li class="mc-select-group__title">{{label}}</li>
        <li>
            <ul class="mc-select-group">
                <slot></slot>
            </ul>
        </li>
    </ul>
</template>

<script type="text/ecmascript-6">
    import Emitter from '../mixins/emitter'

    export default {
        mixins: [Emitter],
        name: 'base-select-group',
        props: {
            label: String
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/base-select-group.vue